<template>
  <v-container fluid class="login-container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5">
        <div class="login-design">
          <v-form
            style="width: 100%"
            v-model="valid"
            @submit.prevent="postLogin"
            enctype="multipart/form-data"
            class="mx-1"
          >
            <v-alert
              v-model="show"
              type="error"
              border="top"
              dismissible
              colored-border
              prominent
              style="width: 100%"
            >
              <v-row v-for="(error, index) in errors" :key="index">
                <span>{{ error }}</span>
              </v-row>
            </v-alert>
            <v-text-field
              filled
              class="no-before"
              color="primary"
              name="username"
              v-model="input.name"
              label="Utilisateur"
              required
              autocomplete="username"
            ></v-text-field>

            <v-text-field
              filled
              class="no-before"
              color="primary"
              v-model="input.password"
              :append-icon="e1 ? 'fa-eye' : 'fa-eye-slash'"
              @click:append="() => (e1 = !e1)"
              name="password"
              label="Mot de passe"
              counter
              required
              :type="e1 ? 'text' : 'password'"
              autocomplete="current-password"
            ></v-text-field>

            <v-btn
              block
              large
              rounded
              color="#FFB300"
              type="submit"
              :elevation="0"
              :disabled="!valid"
            >
              <span class="font-capitalize">Connexion</span>
            </v-btn>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  components: {},
  props: {},
  data() {
    return {
      input: {
        name: "",
        password: ""
      },
      valid: false,
      e1: false,
      mainColor: "#396574",
      outerColor: "#ffffff",
      errors: [],
      show: false
    };
  },
  methods: {
    async postLogin() {
      this.show = false;
      this.errors = [];
      const authData = {
        username: this.input.name,
        password: this.input.password
      };
      try {
        await this.$store.dispatch("login", authData);
      } catch (error) {
        console.error(error);
        for (let key in error.response.data) {
          error.response.data[key].forEach(errorMessage => {
            this.errors.push(`${errorMessage}`);
          });
        }
        this.show = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  position: relative;
  margin-top: 1rem;
  margin-bottom: 7rem;
  .login-design {
    padding: 4rem;
    height: 50vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 0 5rem 0 5rem;
    display: flex;
    align-items: center;
  }
}
</style>
